// @ts-nocheck
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api.js';
import Logo from '../components/shared/Logo.jsx';
import { Mail } from 'lucide-react';

export default function ForgotPassword() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setErr('');
    if (!email) return setErr('Email is required');
    setLoading(true);
    try {
      await api.resetPassword(email);
      setSent(true);
    } catch (e) {
      setErr(e.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={pageStyle}>
      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
          <Logo size={40} iconSize={28} />
        </div>

        {sent ? (
          <>
            <div style={{ marginBottom: 16 }}><Mail size={40} style={{ color: 'var(--color-primary)' }} /></div>
            <h1 style={titleStyle}>Check your inbox</h1>
            <p style={{ color: 'var(--color-text-2)', fontSize: 14, marginBottom: 24 }}>
              If an account exists for <strong>{email}</strong>, you'll receive a reset link shortly.
              Check your spam folder if it doesn't arrive within a few minutes.
            </p>
            <Link to="/login" style={backLink}>Back to sign in</Link>
          </>
        ) : (
          <>
            <h1 style={titleStyle}>Reset your password</h1>
            <p style={{ color: 'var(--color-text-2)', fontSize: 14, marginBottom: 24 }}>
              Enter your email and we'll send you a reset link.
            </p>
            {err && <div style={errBanner}>{err}</div>}
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <label style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text)' }}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  style={{
                    padding: '10px 14px', border: '1px solid var(--color-border)',
                    borderRadius: 8, fontSize: 14, color: 'var(--color-text)',
                    background: 'var(--color-surface)', outline: 'none',
                    transition: 'border-color 0.15s',
                  }}
                  onFocus={e => e.target.style.borderColor = 'var(--color-primary)'}
                  onBlur={e => e.target.style.borderColor = 'var(--color-border)'}
                />
              </div>
              <button type="submit" style={submitBtn(loading)} disabled={loading}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <p style={{ marginTop: 20, fontSize: 13, color: 'var(--color-text-2)' }}>
              Remember it? <Link to="/login" style={linkStyle}>Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'var(--color-bg)', padding: 24,
};
const card = {
  background: 'var(--color-surface)', borderRadius: 14, padding: '40px 36px',
  width: '100%', maxWidth: 400, boxShadow: 'var(--shadow-card)',
  border: '1px solid var(--color-border)', textAlign: 'center',
};
const titleStyle  = { fontSize: 22, fontWeight: 700, marginBottom: 10 };
const errBanner   = {
  background: 'var(--color-red-bg)', border: '1px solid var(--color-red-border)',
  color: 'var(--color-red-text)', borderRadius: 8, padding: '11px 14px',
  marginBottom: 4, fontSize: 14, textAlign: 'left',
};
const submitBtn = (loading) => ({
  background: loading ? 'var(--color-text-3)' : 'var(--color-primary)',
  color: '#fff', border: 'none', borderRadius: 8, padding: 12,
  fontSize: 15, fontWeight: 600, cursor: loading ? 'default' : 'pointer',
  width: '100%',
});
const backLink = { color: 'var(--color-primary)', fontWeight: 600, fontSize: 14 };
const linkStyle = { color: 'var(--color-primary)', fontWeight: 600 };
